var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer flex-0"},[_vm._v("Copyright © 超智云 AI")])
}
var staticRenderFns = []

export { render, staticRenderFns }